var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36255 5.61755C6.94255 5.61755 6.61255 5.95505 6.61255 6.36755C6.61255 6.78005 6.95005 7.11755 7.36255 7.11755C7.77505 7.11755 8.11255 6.78005 8.11255 6.36755C8.11255 5.95505 7.77505 5.61755 7.36255 5.61755Z",
    fill: "#1C83FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.595 3.78C15.965 2.3175 14.5775 1.5 12.6425 1.5H6.3575C3.95 1.5 2 3.45 2 5.8575V12.1425C2 14.0775 2.8175 15.465 4.28 16.095C4.4225 16.155 4.5875 16.1175 4.6925 16.0125L16.5125 4.1925C16.625 4.08 16.6625 3.915 16.595 3.78ZM8.3975 9.18C8.105 9.465 7.7225 9.6 7.34 9.6C6.9575 9.6 6.575 9.4575 6.2825 9.18C5.5175 8.46 4.6775 7.3125 5 5.9475C5.285 4.71 6.38 4.155 7.34 4.155C8.3 4.155 9.395 4.71 9.68 5.955C9.995 7.3125 9.155 8.46 8.3975 9.18Z",
    fill: "#1C83FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1025 15.3975C15.2675 15.5625 15.245 15.8325 15.0425 15.945C14.3825 16.3125 13.58 16.5 12.6425 16.5H6.35754C6.14004 16.5 6.05004 16.245 6.20004 16.095L10.73 11.565C10.88 11.415 11.1125 11.415 11.2625 11.565L15.1025 15.3975Z",
    fill: "#1C83FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 5.85754V12.1425C16.9999 13.08 16.8124 13.89 16.4449 14.5425C16.3324 14.745 16.0624 14.76 15.8974 14.6025L12.0574 10.7625C11.9074 10.6125 11.9074 10.38 12.0574 10.23L16.5874 5.70004C16.7449 5.55004 16.9999 5.64004 16.9999 5.85754Z",
    fill: "#1C83FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.f53c6e739e012399779d5950066edacf.svg";
export { ForwardRef as ReactComponent };